function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".c,.d{fill:#f2c4d5;}.c{font-size:130px;font-family:JosefinSans-SemiBold, Josefin Sans;font-weight:600;}.d{font-size:51px;font-family:JosefinSans-Bold, Josefin Sans;font-weight:700;opacity:0.8;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-20.5 -633.5)"
}, /*#__PURE__*/React.createElement("text", {
  className: "c",
  transform: "translate(20.5 731.5)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "D")), /*#__PURE__*/React.createElement("text", {
  className: "d",
  transform: "translate(52.53 700.745)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "D")));

function SvgImagotype(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 99,
    height: 131,
    viewBox: "0 0 99 131",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagotype);
export default __webpack_public_path__ + "static/media/imagotype.faeae44e.svg";
export { ForwardRef as ReactComponent };